import {
  FETCH_OBJECT_NUM_REQUEST,
  FETCH_OBJECT_NUM_SUCCESS,
  FETCH_OBJECT_NUM_FAILURE,
} from '../types';

const INITIAL_STATE = {
  objectNumList: [],
  loading: false,
  error: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_OBJECT_NUM_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_OBJECT_NUM_SUCCESS:
      return {
        ...state,
        loading: false,
        objectNumList: action.payload,
      };

    case FETCH_OBJECT_NUM_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        objectNumList: [],
      };
    default:
      // ALWAYS have a default case in a reducer
      return state;
  }
};
